export default function unmaskPhoneNumber(phoneNumber: string) {
  return phoneNumber.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
}
